import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";

// List of Services
import DetailService from "@/core/services/detail.service";
import SidebarService from "@/core/services/sidebar.service";
import ReportService from "@/core/services/report.service";
import * as firebase from "firebase";
import "firebase/firestore";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent,
  },
})
export default class EvaluatedDetailComponent extends Vue {
  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  reportService: any = new ReportService();
  user_id: any = [];
  errorReport: boolean = false;
  modal: boolean = false;
  listVideo: boolean = false;
  report: boolean = false;
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modalEvaluated: boolean = false;
  error: boolean = false;
  companyList: any = [];
  profileList: any = [];
  videosList: any = [];
  name: string = "";
  companyName: string = "";
  surname: string = "";
  createdBy: string = "";
  birthdate: string = "";
  email: string = "";
  password: string = "";
  confirm_password: string = "";
  date: string = "";
  companies: boolean = false;
  profile: string = "defaultProfile";
  expiration: string = "";
  company: string = "";
  createdAt: string = "";
  updatedAt: string = "";
  startDate1: string = "";
  startDate2: string = "";
  startDate3: string = "";
  databaseConfig: any;
  isTrainingSuperAdmin: boolean = false;
  isPaqueteExpressAdmin: boolean = false;
  allowGenerateComparative: boolean = false;
  isAdminCfeRole: boolean = false;
  isReporterCfeRole: boolean = false;
  isSuperCfeRole: boolean = false;
  surveyName: "MAP" | "SMAP" | "ACT" = undefined;
  showInviteResendModal: boolean = false;
  userQuestionNumber: number = 0;
  // Surveys config
  mapSurveyId: number = 0;
  selfEvaluationSurvey: number = 0;
  initPersonalStyleSurveyDate: any;
  initCommunicationStyleSurveyDate: any;
  initMapSurveyDate: any;
  personalStylePercentage: any = 0;
  communicationStylePercentage: any = 0;
  mapPercentage: any = 0;
  skillOneScore: any = 0;
  skillOnePercentage: any = 0;
  skillTwoScore: any = 0;
  skillTwoPercentage: any = 0;
  skillThreeScore: any = 0;
  skillThreePercentage: any = 0;
  skillFourthScore: any = 0;
  skillFourthPercentage: any = 0;
  skillFivethPercentage: any = 0;
  skillFivethScore: any = 0;
  skillSixthPercentage: any = 0;
  skillSixthScore: any = 0;
  skillSevenPercentage: any = 0;
  skillSevenScore: any = 0;
  skillEigthPercentage: any = 0;
  skillEigthScore: any = 0;
  skillNinePercentage: any = 0;
  skillNineScore: any = 0;
  skillTenPercentage: any = 0;
  skillTenScore: any = 0;
  skillElevenPercentage: any = 0;
  skillElevenScore: any = 0;
  skillTwelvePercentage: any = 0;
  skillTwelveScore: any = 0;
  skillThirdteenPercentage: any = 0;
  skillThirdteenScore: any = 0;
  skillFourthteenPercentage: any = 0;
  skillFourthteenScore: any = 0;
  // Survey: Auto
  autoSkillOneScore: number = 0;
  autoSkillTwoScore: number = 0;
  autoSkillThreeScore: number = 0;
  autoSkillFourScore: number = 0;
  // Survey: Styles
  stylesSkillOneScore: number = 0;
  stylesSkillTwoScore: number = 0;
  stylesSkillThreeScore: number = 0;
  stylesSkillFourScore: number = 0;

  // Survey videos dictionary
  public orderedSections: string[] = [
    "Conociendo MAP",
    "Demo MAP",
    "Preparado para iniciar",
    "Reunión del Personal",
    "Formato de planeación gerencial",
    "Recordatorio de Luis",
    "Silvia y Jaime discuten un problema",
    "Luis delega a Juan",
    "Juan delega a José",
    "Ana entrevista a Jesús",
    "¿Debería Ana contratar a Jesús?",
    "Luis discute con Jaime un problema",
    "Comunicado de Silvia",
    "La revisión de desempeño de Ana",
    "Jaime aconseja a Hugo",
    "Reunión de Luis con Silvia y Jaime",
    "Generando su perfil de efectividad"
  ];
  
  public surveyVideosDictionary: { [key: string]: string } = {
    introOne: "Conociendo MAP",
    introTwo: "Demo MAP",
    introThree: "Preparado para iniciar",
    jaimeAdviceHugoOne: "Jaime aconseja a Hugo",
    jesusInterviewByAna: "Ana entrevista a Jesús",
    juanDelegatesToJose: "Juan delega a José",
    luisAndAnaOne: "Recordatorio de Luis",
    luisArguesWithJaimeOne: "Luis discute con Jaime un problema",
    luisDelegatesToJuanOne: "Luis delega a Juan",
    luisMeetsAnaOne: "La revisión de desempeño de Ana",
    luisMeetsSilviaOne: "Reunión de Luis con Silvia y Jaime",
    luisPadronOne: "Reunión del Personal",
    managementJaimeOne: "Formato de planeación gerencial",
    questionEigthTwelveOne: "Ana entrevista a Jesús - 8",
    questionElevenTwelveOne: "Ana entrevista a Jesús - 11",
    questionFiveTwelveOne: "Ana entrevista a Jesús - 5",
    questionFourTwelveOne: "Ana entrevista a Jesús - 4",
    questionNineTwelveOne: "Ana entrevista a Jesús - 9",
    questionSevenTwelveOne: "Ana entrevista a Jesús - 7",
    questionSixTwelveOne: "Ana entrevista a Jesús - 6",
    questionTenTwelveOne: "Ana entrevista a Jesús - 10",
    questionThreeTwelveOne: "Ana entrevista a Jesús - 3",
    questionTwelveTwelveOne: "Ana entrevista a Jesús - 12",
    questionTwoTwelveOne: "Ana entrevista a Jesús - 1",
    shouldAnaHireJesusOne: "¿Debería Ana contratar a Jesús?",
    silviAndJaimeOne: "Silvia y Jaime discuten un problema",
    silviaMemorandumOne: "Comunicado de Silvia",
    profileEffectivenessOne: "Generando su perfil de efectividad"
  }

  public surveyVideosDictionaryAct: { [key: string]: string } = {
    introduction: "introduction",
    sandraExperience: "sandraExperience",
    tqmEvaluation: "tqmEvaluation",
    firstMeetA: "firstMeetA",
    firstMeetB: "firstMeetB",
    firstMeetC: "firstMeetC",
    firstMeetD: "firstMeetD",
    firstMeetE: "firstMeetE",
    firstMeetF: "firstMeetF",
    secondMeetA: "secondMeetA",
    secondMeetB: "secondMeetB",
  }

  public sortedVideosObjectAct: { [key: number]: string } = {      
    1: "introduction",
    2: "sandraExperience",
    3: "tqmEvaluation",
    4: "firstMeetA",
    5: "firstMeetB",
    6: "firstMeetC",
    7: "firstMeetD",
    8: "firstMeetE",
    9: "firstMeetF",
    10: "secondMeetA",
    11: "secondMeetB",
    12: "secondMeetC",
    13: "secondMeetD",
    14: "secondMeetE",
    15: "secondMeetF",
    16: "secondMeetG",
    17: "secondMeetH",
    18: "secondMeetI",
    19: "secondMeetJ",
    20: "secondMeetK",
    21: "secondMeetL",
    22: "secondMeetM",
    23: "secondMeetN",
    24: "secondMeetO",
    25: "secondMeetP",
    26: "secondMeetQ",
    27: "secondMeetR",
    28: "secondMeetS",
    29: "secondMeetT",
  }


  public sortedVideosObject: { [key: number]: string } = {      
    1: "luisPadronOne",
    2: "managementJaimeOne",
    3: "luisAndAnaOne",
    4: "silviAndJaimeOne",
    5: "luisDelegatesToJuanOne",
    6: "juanDelegatesToJose",
    7: "jesusInterviewByAna",
    8: "questionTwoTwelveOne",
    9: "questionThreeTwelveOne",
    10: "questionFourTwelveOne",
    11: "questionFiveTwelveOne",
    12: "questionSixTwelveOne",
    13: "questionSevenTwelveOne",
    14: "questionEigthTwelveOne",
    15: "questionNineTwelveOne",
    16: "questionTenTwelveOne",
    17: "questionElevenTwelveOne",
    18: "questionTwelveTwelveOne",
    19: "shouldAnaHireJesusOne",
    20: "luisArguesWithJaimeOne",
    21: "silviaMemorandumOne",
    22: "luisMeetsAnaOne",
    23: "jaimeAdviceHugoOne",
    24: "luisMeetsSilviaOne",
    25: "profileEffectivenessOne"
  }

  // section of Surveys
  introOne: string = "";
  introThree: string = "";
  introTwo: string = "";
  jaimeAdviceHugoOne: string = "";
  jesusInterviewByAna: string = "";
  juanDelegatesToJose: string = "";
  luisAndAnaOne: string = "";
  luisArguesWithJaimeOne: string = "";
  luisDelegatesToJuanOne: string = "";
  luisMeetsAnaOne: string = "";
  luisMeetsSilviaOne: string = "";
  luisPadronOne: string = "";
  managementJaimeOne: string = "";
  questionEigthTwelveOne: string = "";
  questionElevenTwelveOne: string = "";
  questionFiveTwelveOne: string = "";
  questionFourTwelveOne: string = "";
  questionNineTwelveOne: string = "";
  questionSevenTwelveOne: string = "";
  questionSixTwelveOne: string = "";
  questionTenTwelveOne: string = "";
  questionThreeTwelveOne: string = "";
  questionTwelveTwelveOne: string = "";
  questionTwoTwelveOne: string = "";
  shouldAnaHireJesusOne: string = "";
  silviAndJaimeOne: string = "";
  silviaMemorandumOne: string = "";

  mounted() {
    const _ = this;
    if (!firebase.apps.length) {
      firebase.initializeApp({
        apiKey: "AIzaSyBNmQTG75Uwupqcoc_WcMS26yxgcT3_sn4",
        authDomain: "map-only-8263b.firebaseapp.com",
        projectId: "map-only-8263b",
        storageBucket: "map-only-8263b.firebasestorage.app",
        messagingSenderId: "800823508286",
        appId: "1:800823508286:web:335959b2e9098bfe3d806f",
        measurementId: "G-KKTHNEKD9V"
      });
    }
    _.databaseConfig = firebase.firestore();
    _.getByCandidates();
    _.getCompanies();
    _.getProfile();
    _.isTrainingAdmin();
    _.hasPaqueteExpressAccess();
    _.validateCompany();
    _.checkCfeRoles();
    _.getVideos();
  }

  getVideos() {
    const _ = this;
    const resourcesCollection = _.databaseConfig.collection("resourceWasWatch");
    resourcesCollection
      .where("userId", "==", _.user_id)
      .get()
      .then((querySnapshot) => {
        const watchedVideos = new Map();
        _.videosList = []
        let videosObj;
        querySnapshot.forEach((doc) => {
          videosObj = doc.data();
        });
        
        
        for (let [key, value] of Object.entries(videosObj)) {
          const isKeyOnDictionary = this.surveyVideosDictionary[key];
          if (value && isKeyOnDictionary) {
            watchedVideos.set(this.surveyVideosDictionary[key], value);
          }
        }

        _.videosList = Array.from(watchedVideos.keys());
        _.videosList.sort((a, b) => {
          // Get the index of each element in the predefined order array
          const indexA = this.orderedSections.findIndex(section => a.startsWith(section));
          const indexB = this.orderedSections.findIndex(section => b.startsWith(section));
        
          // Handle cases where items are not found (push them to the end)
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
        
          return  indexB - indexA;
        });
      })
      .catch((err) => {
        console.log(err, " Err");
      });
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  public reactivateVideo(videoId: string){
    const resourcesCollection = this.databaseConfig.collection("resourceWasWatch");
    const invertedDictionary = Object.fromEntries(Object.entries(this.surveyVideosDictionary).map(([key, value]) => [value, key]));
    console.log(invertedDictionary, "invertedDictionary")
    resourcesCollection
      .where("userId", "==", this.user_id)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const updateObj = {};
          updateObj[invertedDictionary[videoId]] = false;
          
          console.log(updateObj, "updateObj")
          doc.ref.update(updateObj)
            .then(() => {
              alert("Se reactivó el video con exito!");
              this.modalEvaluated = false;
              this.getVideos();
            })
            .catch((error) => {
              alert("Hubo un error al reactivar el video");
              console.error("Error updating document: ", error);
            });
        });
      })
      .catch((error) => {
        console.error("Error getting documents: ", error);
      });
  }

  filterDate(date = "") {
    const _ = this;
    if (date != null && date != "") {
      date = date.split("T");
      date = date[0];
    }
    return date;
  }

  filterTime(time: any = "") {
    const _ = this;
    if (time != null && time != "") {
      time = time.split("T");
      time = time[1];
      time = time.split(".");
      time = time[0];
    }
    return time;
  }

  private fillMapSurvey(data: any) {
    const _ = this
    for (let i = 0; i < data["data"].report.map.length; i++) {
      this.surveyName = "MAP";
      if (data["data"].report.map[i].id == 9) {
        _.skillOneScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillOnePercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 10) {
        _.skillTwoScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillTwoPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 11) {
        _.skillThreeScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillThreePercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 12) {
        _.skillFourthScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillFourthPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 13) {
        _.skillFivethPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillFivethScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 14) {
        _.skillSixthPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillSixthScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 15) {
        _.skillSevenPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillSevenScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 16) {
        _.skillEigthPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillEigthScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 17) {
        _.skillNinePercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillNineScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 18) {
        _.skillTenPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillTenScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 19) {
        _.skillElevenPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillElevenScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 20) {
        _.skillTwelvePercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillTwelveScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 21) {
        _.skillThirdteenPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillThirdteenScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
      if (data["data"].report.map[i].id == 22) {
        _.skillFourthteenPercentage =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.value
            : null;
        _.skillFourthteenScore =
          data["data"].report.map[i].result != undefined
            ? data["data"].report.map[i].result.percentage
            : null;
      }
    }
  }
  private fillSMapSurvey(data: any) {
    const _ = this
    this.surveyName = "SMAP";
    for (let i = 0; i < data["data"].report.smap.length; i++) {
      if (data["data"].report.smap[i].id == 9) {
        _.skillOneScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillOnePercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 10) {
        _.skillTwoScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillTwoPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 11) {
        _.skillThreeScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillThreePercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 12) {
        _.skillFourthScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillFourthPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 13) {
        _.skillFivethPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillFivethScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 14) {
        _.skillSixthPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillSixthScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 15) {
        _.skillSevenPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillSevenScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 16) {
        _.skillEigthPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillEigthScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 17) {
        _.skillNinePercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillNineScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 18) {
        _.skillTenPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillTenScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 19) {
        _.skillElevenPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillElevenScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 20) {
        _.skillTwelvePercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillTwelveScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 21) {
        _.skillThirdteenPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillThirdteenScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
      if (data["data"].report.smap[i].id == 22) {
        _.skillFourthteenPercentage =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.value
            : null;
        _.skillFourthteenScore =
          data["data"].report.smap[i].result != undefined
            ? data["data"].report.smap[i].result.percentage
            : null;
      }
    }
  }
  private fillActSurvey(data: any) {
    const _ = this
    this.surveyName = "ACT";

    for (let i = 0; i < data["data"].report.act.length; i++) {
      if (data["data"].report.act[i].id === 23) {
        _.skillOneScore =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.value
            : null;
        _.skillOnePercentage =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.percentage
            : null;
      }


      if (data["data"].report.act[i].id === 24) {
        _.skillTwoScore =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.value
            : null;
        _.skillTwoPercentage =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.percentage
            : null;
      }

      if (data["data"].report.act[i].id === 25) {
        _.skillThreeScore =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.value
            : null;
        _.skillThreePercentage =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.percentage
            : null;
      }

      if (data["data"].report.act[i].id === 26) {
        _.skillFourthScore =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.value
            : null;
        _.skillFourthPercentage =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.percentage
            : null;
      }

      if (data["data"].report.act[i].id === 27) {
        _.skillFivethPercentage =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.value
            : null;
        _.skillFivethScore =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.percentage
            : null;
      }

      if (data["data"].report.act[i].id === 28) {
        _.skillSixthPercentage =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.value
            : null;
        _.skillSixthScore =
          data["data"].report.act[i].result != undefined
            ? data["data"].report.act[i].result.percentage
            : null;
      }
    }
  }

  getSurveyAnswers() {
    const _ = this;
    _.detailService
      .getSurveyResults(_.user_id)
      .then((data: any) => {
        // TODO: Refactor all this code
        // Survey: Auto -> Scores
        for (let i = 0; i < data["data"].report.auto.length; i++) {
          if (data["data"].report.auto[i].id == 1) {
            _.autoSkillOneScore = data["data"].report.auto[i].score;
          }
          if (data["data"].report.auto[i].id == 2) {
            _.autoSkillTwoScore = data["data"].report.auto[i].score;
          }
          if (data["data"].report.auto[i].id == 3) {
            _.autoSkillThreeScore = data["data"].report.auto[i].score;
          }
          if (data["data"].report.auto[i].id == 4) {
            _.autoSkillFourScore = data["data"].report.auto[i].score;
          }
        }
        // Survey: Communication -> Scores
        for (let i = 0; i < data["data"].report.communication.length; i++) {
          if (data["data"].report.communication[i].id == 5) {
            _.stylesSkillOneScore = data["data"].report.communication[i].score;
          }
          if (data["data"].report.communication[i].id == 6) {
            _.stylesSkillTwoScore = data["data"].report.communication[i].score;
          }
          if (data["data"].report.communication[i].id == 7) {
            _.stylesSkillThreeScore =
              data["data"].report.communication[i].score;
          }
          if (data["data"].report.communication[i].id == 8) {
            _.stylesSkillFourScore = data["data"].report.communication[i].score;
          }
        }

        const isAct = data["data"].report.act;
        const isMap = data["data"].report.map;
        const isSMap = data["data"].report.smap;

        // ACT
        if (isAct) {
          this.fillActSurvey(data)
        }
        if (isMap) {
        this.fillMapSurvey(data)
        }
        if (isSMap) {
          this.fillSMapSurvey(data)
        }
      })
      .catch((err) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
      });
  }

  getCompanies() {
    const _ = this;
    _.isLoading = true;
    _.detailService
      .getCompanies()
      .then((data: any) => {
        _.companyList = data["data"].companies;
        _.companyList.sort(function(a, b) {
          var textA = a.name.toLowerCase();
          var textB = b.name.toLowerCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  getUserQuestionNumber(questionId: number, surveyId: number) {
    const isMap = surveyId === 3 || surveyId === 4;
    const isAct = surveyId === 5;
    if(isMap) {
      const startingId = 37
      const questionNumber = questionId - startingId;
      this.userQuestionNumber = questionNumber;
      console.log(this.userQuestionNumber, "questhis.userQuestionNumbertionNumber")
      return questionNumber;
    }
    if(isAct) {
      return 23;
    }
  }

  getProfile() {
    const _ = this;
    _.isLoading = true;
    _.detailService
      .getProfile()
      .then((data: any) => {
        _.profileList = data["data"].profiles;
        _.mapPercentage = Math.round(+sessionStorage.getItem("mapPercentage"));
        _.personalStylePercentage = Math.round(
          +sessionStorage.getItem("personalStylePercentage")
        );
        _.communicationStylePercentage = Math.round(
          +sessionStorage.getItem("communicationStylePercentage")
        );

        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  public singleReport(user_id) {
    if(this.surveyName === "MAP" || this.surveyName === "SMAP") {
      this.$router.push(`${'/single-report'}/${user_id}`);
    } else if (this.surveyName === "ACT") {
      this.$router.push(`${'/act'}/${user_id}`);
    }
  }

  vsReport(user_id, profile) {
    const _ = this;
    if (
      _.mapPercentage < Math.round(100) ||
      _.personalStylePercentage < Math.round(100) ||
      _.communicationStylePercentage < Math.round(100)
    ) {
      _.$router.push(`/vs-report/${user_id}/profile/${profile}`);
      // _.modalEvaluated = true;
      // _.error = true;
      // _.modal = false;
    } else {
      _.$router.push(`/vs-report/${user_id}/profile/${profile}`);
      // _.$router.replace({ name: "vs-report", params: {id: 'user_id'}, name: "profile", params: {id: 'profile.id'}})
    }
  }

  getByCandidates() {
    const _ = this;
    _.user_id = location.href.split("/");
    _.user_id = _.user_id[5];
    _.isLoading = true;
    _.detailService
      .getByCandidates(_.user_id)
      .then((data: any) => {
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
        console.log(data["data"].user.surveys)
        _.mapSurveyId = data["data"].user.surveys[2].id;
        _.name = data["data"].user.name;
        _.surname = data["data"].user.surname;
        _.createdBy = data["data"].user.createdBy || "No hay registro";
        _.birthdate = data["data"].user.birthdate;
        _.email = data["data"].user.email;
        _.createdAt = data["data"].user.createdAt;
        const userQuestionNumber = data["data"].user.surveys[2].lastQuestionId;
        const surveyId = data["data"].user.surveys[2].SurveyId;
        this.getUserQuestionNumber(userQuestionNumber, surveyId)

        // _.updatedAt = data["data"].user.updatedAt;
        _.alias = data["data"].user.role.alias;
        _.companyName =
          data["data"].user.company != null
            ? data["data"].user.company.name
            : null;
        _.progress = data["data"].user.surveys[0].progress;
        _.startDate1 = data["data"].user.surveys[0].startDate;
        _.startDate2 = data["data"].user.surveys[1].startDate;
        _.startDate3 = data["data"].user.surveys[2].startDate;
        _.getSurveyAnswers();
      })
      .catch((err: any) => {
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      });
  }

  getProfileReport() {
    const _ = this;
    _.isLoading = true;
    _.reportService
      .getProfileReport(_.user_id, _.profile)
      .then((data: any) => {
        _.isSuccess = true;
        _.isErrorServer = false;
        setTimeout(() => {
          _.isLoading = false;
          _.$router.push(`${data["data"].userSurveyId}/profile/${profileId}`);
        }, 2000);
      })
      .catch((err: any) => {
        _.isErrorServer = true;
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }

  private hasPaqueteExpressAccess() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    const role = localStorage.getItem("role");
    if (companyId === "14" && role === "2") {
      _.isPaqueteExpressAdmin = true;
    }
  }

  private validateCompany() {
    const companyId = localStorage.getItem("company");
    if (companyId === "73") {
      this.allowGenerateComparative = true;
    }
  }

  private checkCfeRoles() {
    const role = localStorage.getItem("role");
    this.isAdminCfeRole = role === "5";
    this.isReporterCfeRole = role === "6";
    this.isSuperCfeRole = role === "7";
  }

  public resendAccountEmail() {
    const _ = this;
    _.detailService
      .resendAccountEmail(_.user_id)
      .then((data: any) => {
        _.showInviteResendModal = true;
        setTimeout(() => {
          _.showInviteResendModal = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.showInviteResendModal = true;
        setTimeout(() => {
          _.showInviteResendModal = false;
        }, 1500);
        console.log(err, " Email sent");
      });
  }
}
